
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec425"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec425"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eZQHH", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeafa51695a8001d$export$2e2bcd8739ae039);
/**
 * Frontend Logger
 * Browser-compatible logging with environment-aware levels
 * No external dependencies - uses native console methods
 */ class $aeafa51695a8001d$var$FrontendLogger {
    constructor(){
        // Determine if we're in development mode
        const isDev = window.location.hostname === 'localhost' || window.location.hostname.includes('dev') || window.location.hostname.includes('127.0.0.1') || window.location.protocol === 'file:';
        // Set log level based on environment
        this.level = isDev ? 'debug' : 'warn';
        // Define log levels with numeric values
        this.levels = {
            debug: 0,
            info: 1,
            warn: 2,
            error: 3
        };
        this.currentLevel = this.levels[this.level];
    }
    // Check if a log level should be output
    shouldLog(level) {
        return this.levels[level] >= this.currentLevel;
    }
    // Format log message with timestamp and metadata
    formatMessage(level, message, ...meta) {
        const timestamp = new Date().toLocaleTimeString('en-US', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
        // Color mapping for different log levels
        const colors = {
            debug: 'color: #666',
            info: 'color: #0066cc',
            warn: 'color: #ff9900',
            error: 'color: #cc0000'
        };
        // Format the message with timestamp and level
        const levelStr = level.toUpperCase().padEnd(5);
        let logLine = `${timestamp} [${levelStr}] ${message}`;
        // Add metadata if present
        if (meta.length > 0) {
            const metaStr = meta.map((item)=>{
                if (typeof item === 'object' && item !== null) return Object.entries(item).map(([k, v])=>`${k}=${v}`).join(' ');
                return String(item);
            }).join(' ');
            if (metaStr) logLine += ` | ${metaStr}`;
        }
        return {
            logLine: logLine,
            color: colors[level] || 'color: inherit'
        };
    }
    // Core logging method
    log(level, ...args) {
        if (!this.shouldLog(level)) return;
        const { logLine: logLine, color: color } = this.formatMessage(level, ...args);
        // Use appropriate console method with styling
        // eslint-disable-next-line no-console
        if (console[level]) // eslint-disable-next-line no-console
        console[level](`%c${logLine}`, color);
        else // eslint-disable-next-line no-console
        console.log(`%c${logLine}`, color);
    }
    // Helper methods for common logging patterns
    auth(action, userId = null, details = {}) {
        const detailsStr = Object.keys(details).length > 0 ? ` | ${Object.entries(details).map(([k, v])=>`${k}=${v}`).join(' ')}` : '';
        this.log('info', `Auth: ${action}${userId ? ` | userId=${userId}` : ''}${detailsStr}`);
    }
    api(method, endpoint, status, duration, userId) {
        const durationStr = duration ? ` | duration=${duration}ms` : '';
        const userIdStr = userId ? ` | userId=${userId}` : '';
        this.log('info', `API: ${method} ${endpoint} | status=${status}${durationStr}${userIdStr}`);
    }
    ui(action, component = null, details = {}) {
        const detailsStr = Object.keys(details).length > 0 ? ` | ${Object.entries(details).map(([k, v])=>`${k}=${v}`).join(' ')}` : '';
        this.log('info', `UI: ${action}${component ? ` | component=${component}` : ''}${detailsStr}`);
    }
    component(lifecycle, componentName, details = {}) {
        const detailsStr = Object.keys(details).length > 0 ? ` | ${Object.entries(details).map(([k, v])=>`${k}=${v}`).join(' ')}` : '';
        this.log('debug', `Component: ${lifecycle} | name=${componentName}${detailsStr}`);
    }
    router(action, path = null, details = {}) {
        const detailsStr = Object.keys(details).length > 0 ? ` | ${Object.entries(details).map(([k, v])=>`${k}=${v}`).join(' ')}` : '';
        this.log('info', `Router: ${action}${path ? ` | path=${path}` : ''}${detailsStr}`);
    }
    // Standard logging methods
    debug(...args) {
        this.log('debug', ...args);
    }
    info(...args) {
        this.log('info', ...args);
    }
    warn(...args) {
        this.log('warn', ...args);
    }
    error(...args) {
        this.log('error', ...args);
    }
    // Additional utility methods
    setLevel(level) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.levels.hasOwnProperty(level)) {
            this.level = level;
            this.currentLevel = this.levels[level];
        }
    }
    getLevel() {
        return this.level;
    }
    // Enable all logging (useful for debugging)
    enableAll() {
        this.setLevel('debug');
    }
    // Disable all logging except errors
    disableAll() {
        this.setLevel('error');
    }
}
var $aeafa51695a8001d$export$2e2bcd8739ae039 = new $aeafa51695a8001d$var$FrontendLogger();

});

// Initialize all global window helpers FIRST, before any components

var $eZQHH = parcelRequire("eZQHH");
window.logger = (0, $eZQHH.default);
window.API = {
    baseURL: '/api',
    async request (endpoint, options = {}) {
        const url = `${this.baseURL}${endpoint}`;
        const startTime = Date.now();
        const method = options.method || 'GET';
        const config = {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            },
            ...options
        };
        (0, $eZQHH.default).debug('API request starting', {
            method: method,
            endpoint: endpoint,
            url: url
        });
        try {
            const response = await fetch(url, config);
            const duration = Date.now() - startTime;
            if (!response.ok) {
                const error = await response.json().catch(()=>({
                        error: 'Request failed'
                    }));
                // Log API error (skip for best-effort optional calls)
                if (!options.silent) (0, $eZQHH.default).api(method, endpoint, response.status, duration, null);
                // Handle authentication errors - dispatch event but preserve actual error message
                if (response.status === 401) document.dispatchEvent(new CustomEvent('auth-required'));
                // Combine error and message if both exist
                let errorMessage = error.error || error.message || `HTTP ${response.status}`;
                if (error.error && error.message && error.error !== error.message) errorMessage = `${error.error}: ${error.message}`;
                // Create enhanced error object with validation details
                const enhancedError = new Error(errorMessage);
                enhancedError.details = error.details; // Preserve validation details array
                enhancedError.statusCode = response.status;
                throw enhancedError;
            }
            // Log successful API call
            (0, $eZQHH.default).api(method, endpoint, response.status, duration, null);
            // Handle 204 No Content (no body)
            if (response.status === 204) return null;
            // Check if response has content
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) return await response.json();
            // For other content types or empty responses, return null
            return null;
        } catch (error) {
            if (!options.silent) (0, $eZQHH.default).error('API request failed', error, {
                method: method,
                endpoint: endpoint,
                duration: Date.now() - startTime
            });
            throw error;
        }
    },
    // Posts API
    posts: {
        getAll: (page = 1, limit = 10)=>window.API.request(`/posts?page=${page}&limit=${limit}`),
        getById: (id)=>window.API.request(`/posts/${id}`),
        create: (data)=>window.API.request('/posts', {
                method: 'POST',
                body: JSON.stringify(data)
            }),
        update: (id, data)=>window.API.request(`/posts/${id}`, {
                method: 'PUT',
                body: JSON.stringify(data)
            }),
        delete: (id)=>window.API.request(`/posts/${id}`, {
                method: 'DELETE'
            })
    },
    postStyles: {
        list: ()=>window.API.request('/post-styles'),
        create: (data)=>window.API.request('/post-styles', {
                method: 'POST',
                body: JSON.stringify(data)
            }),
        update: (id, data)=>window.API.request(`/post-styles/${id}`, {
                method: 'PUT',
                body: JSON.stringify(data)
            }),
        delete: (id)=>window.API.request(`/post-styles/${id}`, {
                method: 'DELETE'
            })
    },
    // Users API
    users: {
        getAll: ()=>window.API.request('/users')
    },
    // Prompts API
    prompts: {
        getPublic: ()=>window.API.request('/prompts/public'),
        getMine: ()=>window.API.request('/prompts/mine'),
        getById: (id)=>window.API.request(`/prompts/${id}`),
        create: (data)=>window.API.request('/prompts', {
                method: 'POST',
                body: JSON.stringify(data)
            }),
        update: (id, data)=>window.API.request(`/prompts/${id}`, {
                method: 'PUT',
                body: JSON.stringify(data)
            }),
        delete: (id)=>window.API.request(`/prompts/${id}`, {
                method: 'DELETE'
            }),
        getPosts: (id)=>window.API.request(`/prompts/${id}/posts`),
        // Admin endpoints
        getAllAdmin: ()=>window.API.request('/prompts/admin/all'),
        updateStatus: (id, status)=>window.API.request(`/prompts/admin/${id}/status`, {
                method: 'PUT',
                body: JSON.stringify({
                    status: status
                })
            })
    },
    // Activities API
    activities: {
        getFriends: (page = 1, limit = 20)=>window.API.request(`/activities/friends?page=${page}&limit=${limit}`)
    },
    // Profile / RSS Feeds
    profile: {
        getRssFeeds: ()=>window.API.request('/profile/rss'),
        addRssFeed: (data)=>window.API.request('/profile/rss', {
                method: 'POST',
                body: JSON.stringify(typeof data === 'string' ? {
                    url: data
                } : data)
            }),
        updateRssFeed: (id, data)=>window.API.request(`/profile/rss/${id}`, {
                method: 'PATCH',
                body: JSON.stringify(data)
            }),
        deleteRssFeed: (id)=>window.API.request(`/profile/rss/${id}`, {
                method: 'DELETE'
            })
    },
    // RSS Feeds (alias for profile methods, used by rss-feeds component)
    rss: {
        list: ()=>window.API.profile.getRssFeeds(),
        add: (data)=>window.API.request('/profile/rss', {
                method: 'POST',
                body: JSON.stringify(typeof data === 'string' ? {
                    url: data
                } : data)
            }),
        getById: (id)=>window.API.request(`/profile/rss/${id}`),
        update: (id, data)=>window.API.profile.updateRssFeed(id, data),
        delete: (id)=>window.API.profile.deleteRssFeed(id)
    },
    // Feed filter settings
    feedFilters: {
        get: (userId)=>window.API.request(`/users/settings/${userId}/feed-filters`),
        update: (userId, data)=>window.API.request(`/users/settings/${userId}/feed-filters`, {
                method: 'PUT',
                body: JSON.stringify(data)
            })
    },
    // Events API
    events: {
        // Subscription methods
        subscribe: (eventId, subscriptionType = 'all_comments')=>window.API.request(`/events/${eventId}/subscribe`, {
                method: 'POST',
                body: JSON.stringify({
                    subscription_type: subscriptionType
                })
            }),
        unsubscribe: (eventId)=>window.API.request(`/events/${eventId}/subscribe`, {
                method: 'DELETE'
            }),
        getSubscriptionStatus: (eventId)=>window.API.request(`/events/${eventId}/subscribe/status`)
    },
    // Polls API
    polls: {
        vote: (postId, optionId)=>window.API.request(`/polls/${postId}/vote`, {
                method: 'POST',
                body: JSON.stringify({
                    option_id: optionId
                })
            }),
        close: (postId)=>window.API.request(`/polls/${postId}/close`, {
                method: 'POST'
            }),
        update: (postId, data)=>window.API.request(`/polls/${postId}`, {
                method: 'PUT',
                body: JSON.stringify(data)
            })
    }
};


//# sourceMappingURL=public.9f994078.js.map
